import React, { useEffect, useState, useRef } from 'react'
import './SingleTravel.min.css'
import axios from 'axios';
import { Travel } from '../TravelsPlanned/model'
import AttractionsTravel from './AttractionsTravel'
import { IoMdAddCircle } from 'react-icons/io'
import { AiFillEdit, AiFillDelete, AiOutlineAppstoreAdd, AiOutlineClose, AiOutlineArrowDown } from 'react-icons/ai'
import Swal from 'sweetalert2'
import { ipAddress } from '../../ipAddress';

interface Groups {
  id: number;
  name: string;
}
interface Props {
  group: Groups;
  travel: Travel;
}
interface Attractions {
  id: number;
  name: string;
  isDone: number;
  description: string;
}

const GroupAttractionsTravel: React.FC<Props> = ({ group, travel }) => {
  const [attractions, setAttractions] = useState<Attractions[]>([]);
  const [attractionsList, setAttractionsList] = useState<boolean>(false);
  const [attractionsList2, setAttractionsList2] = useState<boolean>(false);
  const [nameAttraction, setNameAttraction] = useState<string>('');
  const [menuEditGroup, setMenuEditGroup] = useState<boolean>(false)
  const [edit, setEdit] = useState<boolean>(false);
  const [editGroup, setEditGroup] = useState<string>(group.name);







  const handleDeleteGroup = (id: number, name: string) => {
    Swal.fire({
      title: name,
      text: "Czy jesteś pewien, że chcesz usunąc ten element ?",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + '/deleteAttractionGroupTravel', {
          id: id,
        })


        axios.post(ipAddress + '/deleteAttractionTravelWithGroup', {
          id: id,
        })


      }
    })
    
  }


  const handleAdd5 = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    axios.post(ipAddress + '/addTravelAttractions', {
      id: Math.random(),
      name: nameAttraction,
      isDone: 0,
      cityId: travel.id,
      groupId: id,
      description: '',
    })
      .then((response) => {
        // setBaggages([...baggages, { id: Math.random(), name: descriptionBaggages, isDone: 0 }])
      })
      .catch((err) => {
        console.log(err)
      })

    setNameAttraction('');
    setAttractionsList(false);
    setAttractionsList2(true);


  }
  const inputRef4 = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef4.current?.focus();

  }, [attractionsList])



  const closeAddAttraction = () => {
    setAttractionsList(false);
    setNameAttraction('');
  }

  const resize4 = () => {
    let element = document.getElementById("textAreaAttraction")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }




  const updateTravelAttractions2 = () => {

    axios.post(ipAddress + "/getTravelAttractions", {
      groupId: group.id,
    })
      .then((response) => {
        setAttractions(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })
  }
  updateTravelAttractions2();

  const handleEdit = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    axios.post(ipAddress + "/editGroupAttraction", {
      groupName: editGroup,
      id: id,

    })
      .then((response) => {
        /*  setTravels(travels.map((travel) => (
           travel.id === id ? {...travel, city:editCity , date: editDate } : travel
         ))) */
      })
      .catch(function (error) {
        console.log("error!")

      })

    setEdit(false)
    
  }

  const resize = () => {
    let element = document.getElementById("textAreaEditAttraction")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }

  const close = () => {
    setEdit(false);
    setEditGroup(group.name);
  }


  return (

    <div className='listGroup'>
      {attractions.length > 0 ? (
        <div className='nameGroup'><p><span onClick={() => setAttractionsList2(!attractionsList2)}>{group.name}<span className='icon'><AiOutlineArrowDown /></span></span><span className='menuGroup' onClick={() => setMenuEditGroup(true)}><AiOutlineAppstoreAdd /></span><span className='add' onClick={() => setAttractionsList(true)}><IoMdAddCircle /></span></p></div>
      ) :
        (
          <div className='nameGroup'><p><span onClick={() => setAttractionsList2(!attractionsList2)}></span>{group.name}<span className='menuGroup' onClick={() => setMenuEditGroup(true)}><AiOutlineAppstoreAdd /></span><span className='add' onClick={() => setAttractionsList(true)}><IoMdAddCircle /></span></p></div>
        )
      }
      {menuEditGroup ?
        (<div className='menuEditGroup'>
          <p>{group.name}</p>
          <button className='edit' onClick={() => (setMenuEditGroup(false), setEdit(true))} >Edytuj</button>
          <button className='delete' onClick={() => (setMenuEditGroup(false), handleDeleteGroup(group.id, group.name))} >Usuń</button>
          <button className='cancel' onClick={() => setMenuEditGroup(false)}>Cancel</button>
        </div>
        )
        :
        (<div></div>)}

      {
        edit ? (
          <form className='editGroup' onSubmit={(e) => { handleEdit(e, group.id) }}>
            <button type='button' id='closeEdit' onClick={() => close()} >X</button>
            <p>Edytuj miejscowość do zwiedzania :</p>
            <div className='editGroupName'>
              <textarea id='textAreaEditAttraction'
                rows={2}
                value={editGroup}
                onChange={(e) => (resize(), setEditGroup(e.target.value))}
                onClick={() => resize()}
              ></textarea>
            </div>

            <button type='submit' id='submit'>OK</button>
          </form>
        ) : (
          <span></span>
        )
      }






      {attractionsList ? (
        <div className='addAttraction'>
          <form onSubmit={(e) => { handleAdd5(e, group.id) }}>
            <button type='button' id='close' onClick={() => closeAddAttraction()} >X</button>
            <p id='city'>{group.name}</p>
            <p>Dodaj atrakcje</p>
            <div className='thingName'>

              <textarea id='textAreaAttraction'
                rows={1}
                placeholder='Co chcesz zwiedzić ?'
                value={nameAttraction}
                onChange={(e) => (resize4(), setNameAttraction(e.target.value))}
                required
              ></textarea>
            </div>
            <button type='submit' id='submit'>OK</button>

          </form>
        </div>

      ) : (
        <div></div>
      )

      }

      {attractionsList2 ? (

        <div>

          {attractions.map((attraction) => (
            <AttractionsTravel attractions={attractions} setAttractions={setAttractions}
              attraction={attraction} key={attraction.id} travel={travel} group={group} />
          ))}
        </div>
      ) : (
        <div></div>
      )
      }




    </div >



  )
}

export default GroupAttractionsTravel